import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import getStore from './application-bundles';
import App from './App';
import cache from './utils/cache';
import loadPlugins from './core-plugins';
import defaultConfig from './default-config';
import { connect } from 'redux-bundler-react';
import classnames from 'classnames';
import pkg from '../package.json';
import detectIE from './utils/detect-ie';

import './css/reset.css';

import 'ol/ol.css';
import './css/mdi/css/materialdesignicons.css';
import './css/mapskin/css/mapskin.css';
import './css/maki/maki.css';
import './css/ds-icons/ds-icons.css';
import './css/cm-icons/cm-icons.css';
import './css/fv-icons/fv-icons.css';
import './css/loading-indicator.css';

import './css/bootstrap/dist/css/bootstrap.css';
import './css/bootstrap/css/bootstrap.css';
import './css/bootstrap/css/bootstrap-paper.min.css';

import './css/corpsmap.css';
import './css/bg-colors.css';
import './css/custom.css';

console.log('------ RUNNING CORPSMAP V.' + pkg.version + ' ------');
const isIE= detectIE();
window.isIE = isIE
window.classnames = classnames;
window.React = React;
window.reduxBundlerReact = {connect: connect};

window.cache = cache;

window.CorpsMap = {
  init: (elementId, config) => {

    const rootEl = elementId ? document.getElementById(elementId) : document.getElementById('root');
    const appConfig = Object.assign({}, defaultConfig, config);

    cache.getAll().then((initialData) => {

      initialData.config = {
        default: appConfig
      }
    
      const store = getStore(initialData);
    
      // if(process.env.NODE_ENV === 'development') 
      window.store = store;
    
      loadPlugins(store);
    
      ReactDOM.render(<App store={store} />, rootEl);
    })

  }
}

if(window.STARTUP){
  window.CorpsMap.init();
}else{
  window.CorpsMap.init('root', window.CMCONFIG);
}



